export enum CustomFavicon {
  WCM_ICON = 'wcmIcon',
  WMG_ICON = 'wmgIcon',
  WMG_ICON_16 = 'wmgIcon16',
  WCM_ICON_16 = 'wcmIcon16',
  default = 'default'
}

export type AvailableCustomFavicons = { [key in CustomFavicon]: string };

export const customFavicons: AvailableCustomFavicons = {
  wcmIcon: '/pitch/assets/images/wcm_favicon.ico',
  wcmIcon16: '/pitch/assets/images/wcm_favicon-16x16.png',
  wmgIcon16: '/pitch/assets/images/wmg_favicon-16x16.png',
  wmgIcon: '/pitch/assets/images/wmg_favicon.ico',
  default: '/pitch/assets/favicon.ico'
};
